import { IMqttServiceOptions } from 'ngx-mqtt';
import { mqttApp, mqttOptions } from 'src/environments/mqtt';

export const mqttConfig: IMqttServiceOptions = mqttOptions(mqttApp);
